import { IPagination } from 'models';
import {
	failureActionHandler,
	requestActionHandler,
	successActionHandler,
} from 'store';
import injectReducer from 'store/injectReducer';
import {
	IClientData,
	IClient,
	IClientList,
	IClientsReducer,
	ISurveyData,
	IClientPartnerLimits,
} from './models';
import * as types from './ActionTypes';
import { IUserList } from '../../models';

export const InitialClientsReducer: IClientsReducer = {
	clientList: [],
	surveyData: {
		isLoading: false,
	},
	pagination: {},
	isLoading: false,
	isLoadingClientList: false,
	isLoadingUserList: false,
};

export default injectReducer(InitialClientsReducer, {
	[types.GET_CLIENT_LIST.REQUEST]: requestActionHandler,
	[types.UPDATE_CLIENT_LIST.REQUEST]: requestActionHandler,

	[types.GET_CLIENT_DETAILS.REQUEST]: requestActionHandler,

	[types.GET_CLIENT_DATA.REQUEST]: requestActionHandler,
	[types.UPDATE_CLIENT_DATA.REQUEST]: requestActionHandler,

	[types.POST_NEW_CLIENT.REQUEST]: requestActionHandler,

	[types.DELETE_CLIENT.REQUEST]: requestActionHandler,

	[types.GET_CLIENT_SURVEY_DATA.REQUEST]: (
		state: IClientsReducer,
	): IClientsReducer => ({
		...state,
		surveyData: {
			isLoading: true,
		},
	}),

	[types.GET_CLIENT_USERS.REQUEST]: (state: IClientsReducer) => ({
		...state,
		isLoadingUserList: true,
	}),

	[types.GET_CLIENT_LIST.FAILURE]: failureActionHandler,
	[types.UPDATE_CLIENT_LIST.FAILURE]: failureActionHandler,

	[types.GET_CLIENT_DETAILS.FAILURE]: failureActionHandler,

	[types.GET_CLIENT_DATA.FAILURE]: failureActionHandler,
	[types.UPDATE_CLIENT_DATA.FAILURE]: failureActionHandler,

	[types.POST_NEW_CLIENT.FAILURE]: failureActionHandler,

	[types.DELETE_CLIENT.FAILURE]: failureActionHandler,

	[types.GET_CLIENT_SURVEY_DATA.FAILURE]: (
		state: IClientsReducer,
		{ payload }: { payload: Error },
	) => ({
		...state,
		surveyData: {
			error: payload,
			isLoading: false,
		},
	}),

	[types.GET_CLIENT_USERS.FAILURE]: (
		state: IClientsReducer,
		action: { payload: Error },
	) => ({
		...failureActionHandler(state, action),
		isLoadingUserList: false,
	}),

	[types.DELETE_CLIENT.SUCCESS]: (state: IClientsReducer) => ({
		...successActionHandler(state),
		isClientDeleted: true,
	}),

	[types.GET_CLIENT_SURVEY_DATA.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload: ISurveyData },
	): IClientsReducer => ({
		...state,
		surveyData: {
			data: payload,
			error: undefined,
			isLoading: false,
		},
	}),

	[types.GET_CLIENT_LIST.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload: IPagination<IClientList> },
	) => {
		return {
			...successActionHandler(state),
			clientList: payload.content || [],
			pagination: {
				last: payload.last,
			},
		};
	},

	[types.UPDATE_CLIENT_LIST.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload: IPagination<IClientList> },
	) => ({
		...successActionHandler(state),
		clientList: [...state.clientList, ...(payload.content || [])],
		pagination: {
			last: payload.last,
		},
	}),

	[types.POST_NEW_CLIENT.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload: { id: string } },
	) => ({
		...successActionHandler(state),
		newClientId: payload.id,
	}),

	[types.UPDATE_CLIENT_DATA.SUCCESS]: (state: IClientsReducer) => ({
		...successActionHandler(state),
		isClientUpdated: true,
	}),

	[types.GET_CLIENT_DETAILS.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload?: IClient },
	) => ({
		...successActionHandler(state),
		client: payload,
	}),

	[types.GET_CLIENT_DATA.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload?: IClientData },
	) => ({
		...successActionHandler(state),
		clientData: payload,
	}),

	[types.GET_CLIENT_USERS.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload?: IUserList },
	) => ({
		...successActionHandler(state),
		clientUserList: payload,
		isLoadingUserList: false,
	}),

	[types.GET_PARTNER_LIMITS.SUCCESS]: (
		state: IClientsReducer,
		{ payload }: { payload?: IClientPartnerLimits },
	) => ({
		...successActionHandler(state),
		partnerLimits: payload,
	}),

	[types.RESET_CLIENT_LIST]: (state: IClientsReducer): IClientsReducer => ({
		...successActionHandler(state),
		clientList: [],
	}),

	[types.RESET_NEW_CLIENT]: (state: IClientsReducer): IClientsReducer => ({
		...successActionHandler(state),
		newClientId: undefined,
	}),

	[types.RESET_CLIENT_DETAILS]: (state: IClientsReducer): IClientsReducer => ({
		...successActionHandler(state),
		client: undefined,
	}),

	[types.RESET_CLIENT_ERROR]: (state: IClientsReducer): IClientsReducer => ({
		...successActionHandler(state),
	}),

	[types.RESET_CLIENT_DATA]: (state: IClientsReducer): IClientsReducer => ({
		...successActionHandler(state),
		clientData: undefined,
	}),

	[types.RESET_UPDATE_CLIENT_DATA]: (
		state: IClientsReducer,
	): IClientsReducer => ({
		...successActionHandler(state),
		isClientUpdated: undefined,
	}),

	[types.RESET_IS_CLIENT_DELETED]: (
		state: IClientsReducer,
	): IClientsReducer => ({
		...successActionHandler(state),
		isClientDeleted: undefined,
	}),
});
